module.exports = __webpack_public_path__ + "media/images/country_flags/mk-8f89ed4643c269e3687e2d95b7f5570e.png";